<template>
    <kt-panel>
        <kt-panel-header>
            <kt-panel-header-toolbar>
                <ul class="nav nav-pills" role="tablist">
                    <li class="nav-item">
                        <a class="nav-link active" data-toggle="tab" href="#acceptor_list" role="tab"
                           aria-selected="false">
                            {{ $t('label.acceptor_list') }}
                        </a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link" data-toggle="tab" href="#general-settings" role="tab" aria-selected="false">
                            {{ $t('label.pay_link_general_settings') }}
                        </a>
                    </li>
                </ul>
            </kt-panel-header-toolbar>
        </kt-panel-header>
        <kt-panel-body>
            <div class="tab-content">
                <div class="tab-pane active" id="acceptor_list">
                    <pardakhtShakhsi-filter :action="filterAction"></pardakhtShakhsi-filter>
                    <kt-datatable v-bind="datatableProps" ref="datatable"></kt-datatable>
                </div>
                <div class="tab-pane" id="general-settings">
                    <general-settings></general-settings>
                </div>
            </div>
        </kt-panel-body>
    </kt-panel>
</template>

<script>
import {ApiUrl} from '@/common/api.service'
import {AuthorizationHeader} from '@/common/jwt.service'
import columns from './../datatable/columns'
import actionsColumn from './actions-column'
import pardakhtShakhsiFilter from './pardakht-shakhsi-filter'
import GeneralSettings from './general-pay-link-settings'

export default {
    components: {
        'pardakhtShakhsi-filter': pardakhtShakhsiFilter,
        'general-settings': GeneralSettings,
    },
    data() {
        return {
            query: {}
        }
    },
    computed: {
        datatableProps() {
            return {
                id: "pardakht_shakhsi_datatable",
                data: {
                    type: 'remote',
                    source: {
                        read: {
                            url: ApiUrl.path('admin/pardakht-shakhsi'),
                            method: 'GET',
                            headers: AuthorizationHeader,
                            map: function (res) {
                                return res.data.data
                            },
                            params: {
                                query: this.query
                            },
                        },
                    },

                    pageSize: 10,
                    serverPaging: true,
                    serverFiltering: true,
                    serverSorting: true,
                },
                layout: {},
                pagination: false,
                sortable: true,
                columns: columns,
                actions: actionsColumn
            }
        },
    },
    methods: {
        filterAction(e, query) {
            this.query = query
            if (this.$refs.datatable.KTDatatable) {
                this.$refs.datatable.reload()
            }
        }
    }
}
</script>

<style>

</style>